export class PsWidgets {

    _all; // number
    _pending; // number
    _pendingValidation; // number
    _expired; // number
    _rejected; // number
    _archived; // number
    _noApply; // number

    constructor(
        all,
        pending,
        pendingValidation,
        expired,
        rejected,
        archived,
        noApply,
    ) {
        this._all = all;
        this._pending = pending;
        this._pendingValidation = pendingValidation;
        this._expired = expired;
        this._rejected = rejected;
        this._archived = archived;
        this._noApply = noApply;
    }

    static null() {
        return new this(
            0,
            0,
            0,
            0,
            0,
            0,
            0,
        );
    }

    static fromAPIDashboard(dashboard) {
        const {
            all,
            pending,
            pending_validation,
            expired,
            rejected,
            archived,
            no_apply,
        } = dashboard;

        return new this(
            all,
            pending,
            pending_validation,
            expired,
            rejected,
            archived,
            no_apply,
        );
    }

    all() {
        return this._all;
    }

    pending() {
        return this._pending;
    }

    pendingValidation() {
        return this._pendingValidation;
    }

    expired() {
        return this._expired;
    }

    rejected() {
        return this._rejected;
    }

    archived() {
        return this._archived;
    }

    noApply() {
        return this._noApply;
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/widgets/PsWidgets.js